/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import t from 'tcomb-validation';

export default t.subtype(t.Boolean, (value) => {
  return Boolean(value);
}, 'Truthy');
